<!-- 企业下的人员 -->
<template>
  <div>
    <el-table ref="multipleTable" :data="selectPerson" highlight-current-row border max-height="400px" row-key="userId" @selection-change="getCheckBox" @row-click="peopleDetail">
      <template slot="empty">
        <img :src="zanwu" alt="" />
        <p style="font-size: 16px; color: #000; margin-top: 36px">
          暂无数据
        </p>
      </template>
      <el-table-column v-if="type===1" :selectable="checkboxInit" type="selection" align="center"
        reserve-selection @selection-change="getCheckBox" />
      <el-table-column label="姓名" prop="name" align="center" min-width="100px" />
      <el-table-column label="性别" prop="sex" width="80" align="center">
        <template #default="{row}">
          <span v-if="row.sex=='1'">男</span>
          <span v-if="row.sex=='2'">女</span>
        </template>
      </el-table-column>
      <el-table-column label="部门" prop="deptList" min-width="300px" align="center">
        <template #default="{row}">
          <el-popover trigger="hover" placement="top">
            <p>{{ row.deptList|deptNameUp }}</p>
            <div slot="reference" class="name-wrapper">
              {{ row.deptList|deptNameDown }}
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="手机号" prop="phone" align="center" min-width="100px" />
      <el-table-column label="账号状态" width="120" align="center">
        <template #default="{ row }">
          <userStatus :status="row.isEnabled" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import userStatus from "@/CommonDP/components/status/userStatus";

export default {
  filters: {
    deptNameDown(list) {
      return list.map(({ deptName }) => deptName).join(";");
    },
    deptNameUp(list) {
      return list.map(({ fullDeptName }) => fullDeptName).join(";");
    }
  },
  components: { userStatus },
  props: {
    selectPerson: { type: Array, required: true },
    type: { type: Number, required: true } // 1、组织架构添加人员  2、立项选择人员
  },
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png")
    };
  },
  methods: {
    getCheckBox(val) {
      this.$emit("getCheckBox", val);
    },
    peopleDetail(val) {
      this.$emit("peopleDetail", val);
    },
    checkboxInit(row) {
      if (row.isJoin === 1) {
        return 0;
      } else {
        return 1;
      } // 可勾选
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
